import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import Session from '../../utils/session.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'my-mental-profile',
	templateUrl: './my-mental-profile.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule, RouterLink ]
})
export default class MyMentalProfileView implements OnInit {
	private session: Session = inject(Session);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('booking').then(() => {
			this.onResolve();
		});
	}
	
	onResolve() {
		this.vm.user = this.session.getSession().user;
		
		if (this.vm.user.parentBusinessUser && this.vm.user.parentBusinessUser.businessName) {
			this.vm.infoText = this.angularFilterHelperService.translate('MyMentalProfile.Info')
				.replace('%s', this.vm.user.parentBusinessUser.businessName);
		} else {
			this.vm.infoText = this.angularFilterHelperService.translate('MyMentalProfile.Info_Private_Customer');
		}
		
		var lang: any = this.vm.user.deviceLanguage || 'en_GB';
		if (lang == 'en_GB' || lang == 'et_EE' || lang == 'ru_RU' || lang == 'fi_FI') {
			this.vm.appLogoLang = lang.split("_")[0];
		} else {
			this.vm.appLogoLang = 'en';
		}
		
		if (this.vm.user.origin == 'siffi.com') {
			this.vm.androidLink = 'https://play.google.com/store/apps/details?id=com.siffi&hl=' + this.vm.appLogoLang;
			this.vm.iosLink = 'https://apps.apple.com/app/siffi/id1629846508?platform=iphone';
		} else {
			this.vm.androidLink = 'https://play.google.com/store/apps/details?id=ee.minudoc&hl=' + this.vm.appLogoLang;
			this.vm.iosLink = 'https://apps.apple.com/app/minudoc/id1465732931?platform=iphone';
		}
	}
	
}